import LegalLayout, { Section } from './LegalLayout';

const CONTACT_EMAIL = 'samuelmago7@gmail.com';

const TermsPage = () => {
  return (
    <LegalLayout
      title="Términos de servicio"
      subtitle="Condiciones de uso de AliVan. Al usar la aplicación aceptas estos términos y la Política de privacidad."
      lastUpdated="Febrero 2026"
      testId="terms-page"
    >
      <Section id="acceptance" title="1. Aceptación de los términos">
        <p>El uso de AliVan implica la aceptación plena y sin reservas de los presentes términos. Si no estás de acuerdo con alguna parte, no debes utilizar la aplicación.</p>
        <p>El titular podrá modificar estos términos en cualquier momento. Las modificaciones se comunicarán en esta misma página y entrarán en vigor desde su publicación.</p>
      </Section>

      <Section id="responsibilities" title="2. Responsabilidades del usuario">
        <p>Al usar AliVan te comprometes a:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>Proporcionar información veraz al iniciar sesión y al configurar proyectos.</li>
          <li>No compartir tu cuenta ni tus credenciales con terceros.</li>
          <li>Utilizar la aplicación conforme a la legislación aplicable y respetando derechos de terceros (imagen, propiedad intelectual, protección de menores, etc.).</li>
          <li>No introducir contenido ilegal, discriminatorio, difamatorio, malware ni intentar vulnerar la seguridad de la aplicación.</li>
          <li>Confirmar de forma explícita cualquier publicación en redes sociales antes de que salga: AliVan no publica por su cuenta.</li>
          <li>Mantener seguros los correos y sistemas asociados a tus integraciones OAuth.</li>
        </ul>
      </Section>

      <Section id="api-integrations" title="3. Integraciones con APIs de terceros">
        <p>AliVan se conecta a servicios oficiales de terceros mediante OAuth y APIs autorizadas (Google/YouTube, Meta/Instagram, TikTok, ElevenLabs, entre otros). Al utilizarlas aceptas también las condiciones específicas de cada proveedor.</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>El uso de la API está sujeto a los límites de cuota y aprobación del proveedor.</li>
          <li>Determinadas integraciones pueden requerir aprobación explícita del proveedor y verificación previa de la app.</li>
          <li>AliVan no evade restricciones técnicas ni contractuales impuestas por dichas APIs.</li>
          <li>La interrupción o modificación unilateral de una API por parte del proveedor puede afectar temporalmente al servicio, sin que ello genere responsabilidad para AliVan.</li>
        </ul>
      </Section>

      <Section id="ai-disclaimer" title="4. Aviso sobre inteligencia artificial">
        <p>AliVan utiliza modelos de lenguaje y otros componentes de IA generativa (incluyendo, sin carácter limitativo, modelos de Anthropic, OpenAI, Google y proveedores equivalentes) para producir texto, transcripciones y otros contenidos.</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>Las respuestas pueden contener imprecisiones. Debes verificar información crítica antes de tomar decisiones basadas en ellas.</li>
          <li>La IA no sustituye asesoramiento legal, médico, financiero, psicológico ni profesional cualificado.</li>
          <li>Los resultados generados pueden variar entre sesiones aunque el mensaje sea idéntico.</li>
          <li>El contenido generado por IA es responsabilidad del usuario cuando decida publicarlo o distribuirlo.</li>
        </ul>
      </Section>

      <Section id="ip" title="5. Propiedad intelectual">
        <p>El código, diseño, marca y experiencia de usuario de AliVan pertenecen a su titular. El contenido que tú introduces sigue siendo tuyo; nos otorgas una licencia limitada para procesarlo con el fin de prestar el servicio.</p>
      </Section>

      <Section id="liability" title="6. Limitación de responsabilidad">
        <p>En la medida máxima permitida por la ley aplicable:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>AliVan se presta "tal cual" y "según disponibilidad", sin garantías implícitas.</li>
          <li>El titular no responde por daños indirectos, lucro cesante, pérdida de datos, interrupción del servicio ni consecuencias derivadas del uso de contenidos generados por IA.</li>
          <li>La responsabilidad máxima acumulada del titular, cuando resulte legalmente exigible, se limita al importe efectivamente pagado por el usuario por el servicio en los doce meses anteriores al hecho que genere la reclamación.</li>
        </ul>
      </Section>

      <Section id="termination" title="7. Suspensión y terminación">
        <p>El titular podrá suspender o cancelar cuentas que incumplan estos términos, sin perjuicio de las acciones legales que correspondan. El usuario podrá dejar de usar el servicio en cualquier momento y solicitar la eliminación de su cuenta conforme a la política de privacidad.</p>
      </Section>

      <Section id="law" title="8. Ley aplicable y jurisdicción">
        <p>Estos términos se rigen por la legislación aplicable al lugar de residencia habitual del titular. Para cualquier controversia, las partes se someten a los tribunales competentes de dicho lugar, salvo norma imperativa en contrario que garantice al consumidor un foro de protección.</p>
      </Section>

      <Section id="contact-terms" title="9. Contacto">
        <p>Para cuestiones legales, notificaciones o reclamaciones:</p>
        <p className="text-white">
          Correo: <a href={`mailto:${CONTACT_EMAIL}`} className="text-neon-red hover:underline" data-testid="terms-contact-email">{CONTACT_EMAIL}</a>
        </p>
      </Section>
    </LegalLayout>
  );
};

export default TermsPage;
